import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { TabButtonComponent, TabButtonsComponent } from '@vivli/shared/components';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { ColDef } from 'ag-grid-community';
import { Size, Styles } from '@vivli/shared/theme';
import { useOrganizations } from '@vivli/features/organizations/infrastructure/hook';
import { AssetsConstant } from '@vivli/shared/infrastructure/constants';
import { useNavigate } from 'react-router';
import { AdminHeaderTitleView, AdminHeaderView, GridView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { CSSProperties } from 'react';

const columnDefs: ColDef[] = [
    {
        field: 'name',
        headerName: 'Organization',
        sortable: true,
        filter: true,
        initialSort: 'asc'
    }
];

const subHeaderStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    marginTop: '-15px',
    paddingBottom: Size.PADDING * 1.5,
    paddingLeft: '40px'
};

const containerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr'
};

export const OrganizationsFeature = () => {
    const { hasPermission } = useActiveUserContext();
    const isVivliAdmin = hasPermission(PermissionsEnum.CreateOrg);
    const { organizations } = useOrganizations();
    const navigate = useNavigate();
    const subHeader = 'Organizations I belong to on the Vivli platform';

    const handleRowClick = (organization: IOrganization) => {
        navigate(`/admin/orgs/${organization.id}`);
    };

    return (
        <div style={containerStyle}>
            <AdminHeaderView>
                <AdminHeaderTitleView title="My Organizations" />
            </AdminHeaderView>
            <div style={subHeaderStyle}>{subHeader}</div>
            <div style={{ padding: '0 40px', height: '100%' }}>
                {
                    //TODO PERMFE - redo with permissions + 1 below+
                    isVivliAdmin && (
                        <div style={{ ...Styles.CENTERED_FLEX, width: '100%' }}>
                            <TabButtonsComponent
                                outerStyle={{ width: '100%' }}
                                commandImage={AssetsConstant.PLUS_SYMBOL}
                                commandTitle={'Add Organization'}
                                commandOnClick={() => navigate('/admin/orgs/add')}
                            >
                                <TabButtonComponent title={'All Organizations'} isSelected={true} />
                            </TabButtonsComponent>
                        </div>
                    )
                }
                <GridView
                    rowData={organizations}
                    columns={columnDefs}
                    onRowClick={handleRowClick}
                    fullWidthColumns={true}
                    hideFloatingFilter={false}
                    style={{
                        marginTop: 0,
                        cursor: 'pointer',
                        height: isVivliAdmin ? '70%' : '80%'
                    }}
                    hideHeader={true}
                    emptyMessage="No Organizations Found"
                />
            </div>
        </div>
    );
};
